/**
 * Allys Property List Card
 * 
 * Theme-specific wrapper for PropertyListCard with Allys branding
 * Provides Phosphor icons and Allys colors to the core component
 */

'use client';

import { ArrowsOut, Bathtub, Bed } from '@phosphor-icons/react';
import { PropertyListCard } from '../../../../src/components/properties/PropertyListCard';
import type { Property } from '../../../../src/lib/api/clients/properties';

export interface AllysPropertyListCardProps {
  property: Property;
  locationName?: string;
  labels?: {
    bedrooms?: string;
    bathrooms?: string;
    area?: string;
    land?: string;
    viewDetails?: string;
    save?: string;
    saved?: string;
    share?: string;
    contactAgent?: string;
    askingPrice?: string;
    built?: string;
    renovated?: string;
    parking?: string;
    garage?: string;
    sold?: string;
    reserved?: string;
    contactForPrice?: string;
  };
  href?: string;
  className?: string;
}

/**
 * AllysPropertyListCard - Allys-themed wrapper for core PropertyListCard
 * Provides Phosphor icons with Allys navy and gold colors
 */
export function AllysPropertyListCard({
  property,
  locationName,
  labels,
  href,
  className = '',
}: AllysPropertyListCardProps) {
  return (
    <PropertyListCard
      property={property}
      {...(locationName && { locationName })}
      {...(labels && { labels })}
      {...(href && { href })}
      className={`border-2 border-gray-100 hover:border-[#BBA339]/30 ${className}`}
      icons={{
        bedroom: Bed,
        bathroom: Bathtub,
        area: ArrowsOut,
      }}
      iconColors={{
        bedroom: '#243462', // Allys Navy
        bathroom: '#BBA339', // Allys Gold
        area: '#6B7280', // Neutral Gray
      }}
    />
  );
}
